import { useMemo } from 'react';

const useModifiers = (mods: string[] | undefined): string => {
  const modifiers = useMemo(() => {
    if (mods) {
      const combinedMods = mods.map((mod: string) => `_${mod} `).join('');
      return combinedMods;
    }

    return '';
  }, [mods]);

  return modifiers;
};

export default useModifiers;
